import { StyleSheet, View } from 'react-native';
import { tokens } from '../../theme/tokens';
import { AppButton } from './AppButton';
import { AppText } from './AppText';

type EmptyViewProps = {
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
};

export function EmptyView({ title, description, actionLabel, onAction }: EmptyViewProps) {
  return (
    <View style={styles.container}>
      <AppText variant="subtitle" weight="semibold" align="center">
        {title}
      </AppText>
      {description ? (
        <AppText tone="muted" align="center" style={styles.description}>
          {description}
        </AppText>
      ) : null}
      {actionLabel && onAction ? (
        <AppButton label={actionLabel} onPress={onAction} style={styles.action} />
      ) : null}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    justifyContent: 'center',
    padding: tokens.spacing.xxl,
  },
  description: {
    marginTop: tokens.spacing.sm,
  },
  action: {
    marginTop: tokens.spacing.lg,
  },
});
